import { Button } from '@mui/material'
import { InformationModal } from 'utoniq-ui'

import { IonInformationModal } from '@/components/organisms/functionals'
import { useRouter, useTranslation } from '@/core'
import { Organism } from '@/core/architecture'

export type CardRegisterModalProps = {
  open: boolean
  useIon?: boolean
  onClose: () => void
}
export const CardRegisterModal: Organism<CardRegisterModalProps> = ({
  open,
  onClose,
  useIon,
}) => {
  const { t } = useTranslation('prepaidPointCharge')
  const { routerPages, router } = useRouter()
  const Component = useIon ? IonInformationModal : InformationModal
  return (
    <Component
      disableEnforceFocus
      open={open}
      onClose={onClose}
      title={t('CardRegisterModalTitle')}
      content={t('CardRegisterModalDescription')}
      buttons={
        <>
          <Button
            sx={{ minWidth: 212 }}
            variant="contained"
            color="primary"
            size="large"
            onClick={() => {
              router.push(routerPages.PaymentDetail)
            }}
          >
            {t('confirmRegisterModal', 'カード情報を登録')}
          </Button>
          <Button
            sx={{ minWidth: 212 }}
            variant="text"
            color="primary"
            onClick={onClose}
          >
            {t('cancel')}
          </Button>
        </>
      }
    />
  )
}
